"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.CurrencyFormat = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _currency = require("../../utils/currency");
var _excluded = ["value", "currencyCode", "prefix", "postfix", "className"];
var CurrencyFormat = exports.CurrencyFormat = function CurrencyFormat(props) {
  var _props$value = props.value,
    value = _props$value === void 0 ? 0 : _props$value,
    currencyCode = props.currencyCode,
    _props$prefix = props.prefix,
    prefix = _props$prefix === void 0 ? '' : _props$prefix,
    _props$postfix = props.postfix,
    postfix = _props$postfix === void 0 ? '' : _props$postfix,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    otherProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var formattedValue = (0, _currency.formatCurrency)(value, currencyCode);
  return /*#__PURE__*/_react["default"].createElement("span", (0, _extends2["default"])({}, otherProps, {
    className: className
  }), prefix ? /*#__PURE__*/_react["default"].createElement("span", null, prefix) : null, /*#__PURE__*/_react["default"].createElement("span", null, formattedValue), postfix ? /*#__PURE__*/_react["default"].createElement("span", null, postfix) : null);
};
var _default = exports["default"] = CurrencyFormat;